import { combineReducers } from 'redux';
import commentContexts, {
  State as CommentContextsState,
} from './CommentContexts';
import controls, { State as ControlsState } from './Controls';
import snippets, { State as SnippetsState } from './Snippets';
import summary, { State as SummaryState } from './Summary';

export interface CommentHistoryState {
  commentContexts: CommentContextsState;
  controls: ControlsState;
  snippets: SnippetsState;
  summary: SummaryState;
}

export default combineReducers<CommentHistoryState>({
  commentContexts,
  controls,
  snippets,
  summary,
});
